export const PROTOCOL = 'Protocolo'
export const B2B = 'Portal B2B'
export const EXPLORERS = 'Operaciones'
export const MONITORING = 'Monitorización'
export const ADMIN = 'Administración'
export const MANAGEMENT = 'Gestión'
export const COMMSERVICES = 'Commservices'

